export enum Variant {
    MSL = 'MSL',
    publisher = 'publisher',
    versioning = 'versioning',
}
